import "./DeleteSectionModal.scss";

import { FC, useState } from "react";

import { t } from "i18n/i18n";
import { LegacyButton } from "mds/components/LegacyButton";
import { showConfirmationModal } from "mds/components/Modal";
import { TextField } from "mds/components/TextField";
import { useAppSelector } from "store";
import { selectCourseTitleBySectionId } from "store/selectors/section";

export const showDeleteConfirmationModal = ({
  sectionId,
  sectionTitle,
}: {
  sectionId: string;
  sectionTitle: string;
}) => {
  const deleteSectionTitle = t("confirm_delete_modal.delete_item", {
    item: t("glossary.section"),
  });

  return showConfirmationModal({
    title: deleteSectionTitle,
    hideCancelConfirmButtons: true,
    labelText: t("confirm_delete_modal.delete_label", { name: sectionTitle }),

    children: (onClose, onConfirm) => (
      <DeleteSectionModal
        deleteSectionTitle={deleteSectionTitle}
        sectionId={sectionId}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    ),
  });
};

type DeleteSectionModalProps = {
  deleteSectionTitle: string;
  sectionId: string;
  onConfirm: (data?: boolean) => void;
  onClose: () => void;
};

// eslint-disable-next-line react-refresh/only-export-components
const DeleteSectionModal: FC<DeleteSectionModalProps> = ({
  sectionId,
  deleteSectionTitle,
  onConfirm,
  onClose,
}) => {
  const [disableDelete, setDisableDelete] = useState<boolean>(true);

  const courseTitle = useAppSelector((state) => selectCourseTitleBySectionId(state, sectionId));
  const handleCourseCodeConfirmationCheck = (text: string) => {
    setDisableDelete(text !== courseTitle);
  };

  return (
    <div className="section-delete-modal mt-8 flex flex-col items-start gap-8">
      <div className="section-delete-warning">{t("section_list_panel.delete_section_warning")}</div>

      <div className="flex flex-col gap-2">
        <label htmlFor="course-code">{t("section_list_panel.course_confirm_label")}</label>

        <TextField
          id="course-code"
          placeholder={t("section_list_panel.course_placeholder")}
          isEditing
          onChange={(event) => handleCourseCodeConfirmationCheck(event.target.value)}
        />
      </div>

      <div className="flex w-full justify-end gap-2">
        <LegacyButton kind="secondary" title={t("common.cancel")} onClick={onClose}>
          {t("common.cancel")}
        </LegacyButton>

        <LegacyButton
          disabled={disableDelete}
          kind="destructive"
          title={deleteSectionTitle}
          onClick={() => onConfirm(true)}
        >
          {deleteSectionTitle}
        </LegacyButton>
      </div>
    </div>
  );
};
